// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { BrowserNotSupported } from './browser-not-supported'

const COMPONENT_ID = 'browserNotSupported'

export const showBrowserNotSupported = () => addModal({ id: COMPONENT_ID })

export default {
  [COMPONENT_ID]: {
    Component: BrowserNotSupported,
  },
}
